export default "__VITE_ASSET__D2qEweT9__"